import React, {useCallback} from 'react';
import {BalloonEventModel} from 'ts-core';
import {FaRegClone} from "react-icons/fa";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslations, useUser} from "react-ui";
import {useCreatorModalSafe} from '../contexts/CreatorModal';

interface CloneButtonProps {
    event: BalloonEventModel;
}

export function CloneButton({event}: CloneButtonProps) {
    const {translated} = useTranslations();
    const {requiresUser} = useUser();
    const creatorModal = useCreatorModalSafe();
    const navigate = useNavigate();
    const location = useLocation();

    const onClick = useCallback(() => {
        if (creatorModal) {
            requiresUser({
                callback: () => {
                    // The URL still points at the original event after cloning,
                    // which is misleading — the user is creating a new balloon,
                    // not viewing the source. Navigate away so the URL and the
                    // sidebar (closed via EventDetailPage's pathname watcher)
                    // match the new intent.
                    if (
                        location.pathname.startsWith('/event/') ||
                        location.pathname.startsWith('/details/')
                    ) {
                        navigate('/');
                    }
                    creatorModal.openCreatorForClone(event);
                }
            });
        }
    }, [creatorModal, event, requiresUser, location.pathname, navigate]);

    return (
        <button
            onClick={onClick}
            className={"flex justify-center items-center w-[36px] h-[36px] text-balloon hover:text-white bg-transparent hover:bg-balloon rounded-full p-2"}
            aria-label={translated("clone") || "Clone"}
            title={translated("clone") || "Clone"}
        ><FaRegClone size={18}/></button>
    );
}
